import { render } from "./Wortelkanaalbehandeling.vue?vue&type=template&id=2930eeb8&scoped=true"
import script from "./Wortelkanaalbehandeling.vue?vue&type=script&lang=js"
export * from "./Wortelkanaalbehandeling.vue?vue&type=script&lang=js"

import "./Wortelkanaalbehandeling.vue?vue&type=style&index=0&id=2930eeb8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2930eeb8"]])

export default __exports__